import styled, { css } from 'styled-components';

import Frame from '../../../../../frame.styles';

export const Card = styled(Frame)<{ isSelected: boolean }>`
  display: flex;
  padding: 0;

  ${(props) =>
    props.isSelected &&
    css`
      background: var(--primary-light);
    `}
`;

export const ImageWrapper = styled.div`
  flex-shrink: 0;
  width: 112px;
  height: 112px;
  border-radius: var(--border-radius);
  overflow: hidden;
`;

export const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const ContentWrapper = styled.div`
  flex: 1;
  padding: 16px;
  display: flex;
  justify-content: space-between;
  gap: 16px;
`;

export const Name = styled.h3`
  margin: 0;
  font-size: 16px;
  line-height: 24px;
`;

export const Icon = styled.div`
  flex-shrink: 0;
  line-height: 0;
`;
